import { fromZonedTime } from 'date-fns-tz';

export const zonedTimeToUtc = (date: Date | string, timeZone: string): Date => {
    return fromZonedTime(date, timeZone);
};
